function initMegaMenu() {
  document.querySelectorAll(".header__nav--listItem").forEach(function (item) {
    const id = item.id;
    if (!id) return;
    const megaMenu = document.querySelector(
      `.megaMenuWrapper[data-menu="${id}"]`,
    );
    const headerOverlay = document.querySelector(".headerOverlay");

    let timer;

    function addActive() {
      item.classList.add("active");
      if (megaMenu) megaMenu.classList.add("active");
      if (headerOverlay) headerOverlay.classList.add("active");

      if (timer) clearTimeout(timer);
    }

    function removeActive() {
      timer = setTimeout(() => {
        item.classList.remove("active");
        if (megaMenu) megaMenu.classList.remove("active");
        if (headerOverlay) headerOverlay.classList.remove("active");
      }, 100);
    }

    item.addEventListener("mouseenter", addActive);
    item.addEventListener("mouseleave", removeActive);

    if (megaMenu) {
      megaMenu.addEventListener("mouseenter", addActive);
      megaMenu.addEventListener("mouseleave", removeActive);
    }
  });

  document.querySelectorAll(".megaMenu").forEach(function (megaMenu) {
    const items = megaMenu.querySelectorAll(".megaMenu__item");
    if (items.length > 0) items[0].classList.add("active");

    items.forEach(function (item) {
      const title = item.querySelector(".megaMenu__item--title");
      if (title) {
        title.addEventListener("click", function (e) {
          items.forEach((i) => i.classList.remove("active"));
          item.classList.add("active");
        });
      }
    });
  });

  document.querySelectorAll(".megaMenu__subMenu").forEach(function (subMenu) {
    const items = subMenu.querySelectorAll(".megaMenu__subMenu--item");
    if (items.length > 0) items[0].classList.add("active");
    items.forEach(function (item, idx) {
      item.addEventListener("mouseenter", function () {
        items.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");
      });
    });
  });
}

function initMegaMenuMob() {
  const navBtnWrapper = document.querySelector(".navBtnWrapper");

  navBtnWrapper.addEventListener("click", function () {
    navBtnWrapper.classList.toggle("active");
    const headerNav = document.querySelector(".header__nav");
    if (headerNav) {
      headerNav.classList.toggle("show");
    }
    document
      .querySelectorAll(
        ".megaMenuWrapper.show, .megaMenu__subMenuWrapper.show, .megaMenu__innerMenuWrapper.show",
      )
      .forEach(function (el) {
        el.classList.remove("show");
      });

    // Toggle overflow-hidden on <html>
    document.documentElement.classList.toggle("overflow-hidden");
  });

  // MegaMenu InnerMenu BackBtn functionality
  const backBtns = document.querySelectorAll(
    ".megaMenu__innerMenuWrapper .backBtn",
  );
  backBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".megaMenu__innerMenuWrapper");
      if (wrapper) {
        wrapper.classList.remove("show");
      }
      // Do NOT remove overflow-hidden here
    });
  });

  // MegaMenu InnerMenu Btn functionality
  const innerMenuBtns = document.querySelectorAll(".innerMenu__btn");
  innerMenuBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentItem = btn.closest(".megaMenu__subMenu--item");
      if (parentItem) {
        const wrapper = parentItem.querySelector(".megaMenu__innerMenuWrapper");
        if (wrapper) {
          wrapper.classList.add("show");
        }
      }
      document.documentElement.classList.add("overflow-hidden");
    });
  });

  const subMenuBackBtns = document.querySelectorAll(
    ".megaMenu__subMenuWrapper__backBtn",
  );
  subMenuBackBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".megaMenu__subMenuWrapper");
      if (wrapper) {
        wrapper.classList.remove("show");
      }
      // Do NOT remove overflow-hidden here
    });
  });

  const subMenuBtns = document.querySelectorAll(".subMenu__btn");
  subMenuBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentItem = btn.closest(".megaMenu__item");
      if (parentItem) {
        const wrapper = parentItem.querySelector(".megaMenu__subMenuWrapper");
        if (wrapper) {
          wrapper.classList.add("show");
        }
      }
      document.documentElement.classList.add("overflow-hidden");
    });
  });

  const megaMenuWrapperBackBtns = document.querySelectorAll(
    ".megaMenuWrapper__backBtn",
  );
  megaMenuWrapperBackBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".megaMenuWrapper");
      if (wrapper) {
        wrapper.classList.remove("show");
      }
      // Do NOT remove overflow-hidden here
    });
  });

  // Menu Btn functionality for multiple megaMenuWrapper
  const menuBtns = document.querySelectorAll(".menu__btn");
  menuBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      // Get id from parent .header__nav--listItem
      const parentItem = btn.closest(".header__nav--listItem");
      if (!parentItem) return;
      const btnId = parentItem.id;
      if (!btnId) return;
      // Find all megaMenuWrapper and match data-menu
      const wrappers = document.querySelectorAll(".megaMenuWrapper");
      wrappers.forEach((wrapper) => {
        const menuAttr = wrapper.getAttribute("data-menu");
        if (menuAttr === btnId) {
          wrapper.classList.add("show");
        } else {
          wrapper.classList.remove("show"); // Optionally hide others
        }
      });
      document.documentElement.classList.add("overflow-hidden");
    });
  });
}

function MegaMenu() {
  if (window.innerWidth > 1199) {
    initMegaMenu();
  } else {
    initMegaMenuMob();
  }
}

export default MegaMenu;
